<template>
  <div class="tabs__wrapper">
    <div
      v-for="(tabItem, i) in tabs"
      :key="tabItem"
      class="tab"
      :class="{
        'tab--active': tab === i,
        'tab--uppercase': $isAndroid,
      }"
      @click="$emit('update:tab', i)"
    >
      {{ tabItem }}
    </div>
  </div>
  <div
    class="slider"
    :style="{
      height: '2px',
      width: `calc(100% / ${tabs.length})`,
      transform: `translate(${100 * progress * (tabs.length - 1)}%)`,
      transition: `transform ${transition}ms ease`,
    }"
  ></div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    tab: {
      type: Number,
      required: true,
    },
    progress: {
      type: Number,
      default: 0,
    },
    transition: {
      type: [Number, String],
      default: 200,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.tabs__wrapper {
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;

  .tab {
    flex: 1;
    position: relative;
    text-align: center;
    color: #444444;

    &--active {
      font-family: Roboto-Bold;
      color: $colorRed;
    }

    &--uppercase {
      font-size: 14px;
      text-transform: uppercase !important;
    }
  }
}

.slider {
  background-color: $colorKaspiRed;
  transition: transform 0.1s cubic-bezier(0.75, 0.75, 0.51, 0.86);
}
</style>
